import { render, staticRenderFns } from "./RecommendedBlog.vue?vue&type=template&id=0f3913ac&scoped=true&lang=pug&"
import script from "./RecommendedBlog.vue?vue&type=script&lang=js&"
export * from "./RecommendedBlog.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedBlog.vue?vue&type=style&index=0&id=0f3913ac&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3913ac",
  null
  
)

export default component.exports